export default __webpack_public_path__ + "static/media/Our_Business.1624731f.png";